import React, {FC, useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {fetchData, toasterrormsg, toastsuccessmsg} from '../../../reusable'
import {ToastContainer} from 'react-toastify'
import {AddHotelHeader} from './AddHotelHeader'
import {Tr} from '../../../_metronic/i18n/Tr'
import {KTIcon} from '../../../_metronic/helpers'
import {useIntl} from 'react-intl'

const ViewHotelContract: FC = () => {
  const t = Tr()
  const intl = useIntl()
  // translate a message that has links inside it, e.g. t('... {didox} ...') with didox as an <a>
  const tLinks = (id: string, values: Record<string, React.ReactNode>) =>
    React.Children.toArray(intl.formatMessage({id, defaultMessage: id}, values as any))
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId')
  useEffect(() => {
    if (categoryId != '1') {
      navigate('../dashboard/')
    }
  }, [categoryId])
  const location = useLocation()
  const editHotelId = (location.state as any)?.hotelId || ''
  const [hotelDetails, setHotelDetails] = useState([]) as any

  var vendorId = ''
  const vendorData = sessionStorage.getItem("vendor")
  if (vendorData) {
    var vendor = JSON.parse(vendorData)
    vendorId = vendor.vendorId
  } else {
    console.log('No vendor data found')
  }
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [tab, setTab] = useState('1')
  const [isAgreeContract, setIsAgreeContract] = useState(false)
  const [contractPdfUrl, setContractPdfUrl] = useState('')
  const [contractPdfError, setContractPdfError] = useState(false)

  const hotelDetailsApiCall = async () => {
    var param: any = {
      hotelId: editHotelId,
    }
    var response: any = await fetchData('public/hotelDetailsV2', param)
    if (response.status == '200') {
      setHotelDetails(response.data)
      var data = response.data[0]
      setIsAgreeContract(data.isAgreeContract == 1)
      if (data.contractPdf) {
        loadContractPdf(data.contractPdf)
      }
    } else {
      toasterrormsg(response.message)
    }
  }

  // the contract file is served by the api and needs the apitoken header,
  // so fetch it here and show it from a blob instead of pointing the iframe at the url
  const loadContractPdf = async (fileUrl: string) => {
    setContractPdfError(false)
    try {
      const response = await fetch(fileUrl, {
        headers: {apitoken: process.env.REACT_APP_API_TOKEN || ''},
      })
      const blob = await response.blob()
      if (!response.ok || blob.type.indexOf('pdf') == -1) {
        setContractPdfError(true)
        return
      }
      setContractPdfUrl(window.URL.createObjectURL(blob))
    } catch (error) {
      setContractPdfError(true)
    }
  }

  useEffect(() => {
    if (editHotelId != '') {
      hotelDetailsApiCall()
    }
  }, [])

  useEffect(() => {
    return () => {
      if (contractPdfUrl) {
        window.URL.revokeObjectURL(contractPdfUrl)
      }
    }
  }, [contractPdfUrl])

  const generateContractPdf = async () => {
    setLoading(true)
    setDisable(true)
    var param: any = {
      actionId: editHotelId,
      categoryId: categoryId,
      vendorId: vendorId,
    }
    var response: any = await fetchData('public/generatePdfContract', param)
    if (response.status == '200') {
      const data = response.data
      const fileUrl = data.url
      if (fileUrl) {
        const link = document.createElement('a')
        link.href = fileUrl
        link.setAttribute('download', 'contract.pdf') // Optional
        link.setAttribute('target', '_blank') // Optional
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else {
        toasterrormsg(t('File URL not found.'))
      }
      setLoading(false)
      setDisable(false)
    } else {
      toasterrormsg(response.message)
      setLoading(false)
      setDisable(false)
    }
  }
  const contractAgree = async () => {
    setLoading(true)
    var param: any = {
      actionId: editHotelId,
      categoryId: categoryId,
      vendorId: vendorId,
    }
    var response: any = await fetchData('public/isContractAgree', param)
    if (response.status == '200') {
      toastsuccessmsg(t('Contract Agreement Saved Successfully!'))
      setTimeout(() => {
        navigate('../viewhotels/')
        setLoading(false)
      }, 1500)
    } else {
      toasterrormsg(response.message)
      setLoading(false)
    }
  }
  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('Contract Agreement')}</PageTitle>
      <AddHotelHeader hotelId={editHotelId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Contract Agreement')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {hotelDetails.length != 0 ? (
                            <>
                              {hotelDetails.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['propertyDetail']) {
                                  percentage = 40
                                }
                                if (completedSteps['completedSteps']['roomAndSpace']) {
                                  percentage = 50
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <React.Fragment key={index}>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{width: `${percentage}%`}}
                                      ></div>
                                    </div>
                                  </React.Fragment>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{t('Completion')}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{width: '0%'}}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-5'>
                        <div className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid first'>
                          <div className='card d-flex bg-gray-100 justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px me-9'>
                            <div className='card-body px-6 px-lg-10 px-xxl-15 py-20'>
                              <div className='stepper-nav'>
                                <div
                                  className='stepper-item cursor-pointer'
                                  onClick={() => setTab('1')}
                                >
                                  <div className='stepper-wrapper'>
                                    <div
                                      className={`stepper-icon w-40px h-40px ${
                                        tab == '1' ? ' bg-success' : 'bg-light-success'
                                      }`}
                                    >
                                      <i className='stepper-check fas fa-check'></i>
                                      <span
                                        className={`stepper-number text-white ${
                                          tab == '1' ? ' text-white' : 'text-success'
                                        }`}
                                      >
                                        1
                                      </span>
                                    </div>
                                    <div className='stepper-label'>
                                      <h3 className='stepper-title'>{t('Conclusion of the Contract')}</h3>
                                    </div>
                                  </div>
                                  <div className='h-40px'></div>
                                </div>
                                <div
                                  className='stepper-item cursor-pointer'
                                  onClick={() => setTab('2')}
                                >
                                  <div className='stepper-wrapper'>
                                    <div
                                      className={`stepper-icon w-40px h-40px ${
                                        tab == '2' ? ' bg-success' : 'bg-light-success'
                                      }`}
                                    >
                                      <i className='stepper-check fas fa-check'></i>
                                      <span
                                        className={`stepper-number text-white ${
                                          tab == '2' ? ' text-white' : 'text-success'
                                        }`}
                                      >
                                        2
                                      </span>
                                    </div>
                                    <div className='stepper-label'>
                                      <h3 className='stepper-title'>{t('Signing via didox.uz')}</h3>
                                    </div>
                                  </div>
                                  <div className='h-40px'></div>
                                </div>
                                <div
                                  className='stepper-item cursor-pointer'
                                  onClick={() => setTab('3')}
                                >
                                  <div className='stepper-wrapper'>
                                    <div
                                      className={`stepper-icon w-40px h-40px ${
                                        tab == '3' ? ' bg-success' : 'bg-light-success'
                                      }`}
                                    >
                                      <i className='stepper-check fas fa-check'></i>
                                      <span
                                        className={`stepper-number text-white ${
                                          tab == '3' ? ' text-white' : 'text-success'
                                        }`}
                                      >
                                        3
                                      </span>
                                    </div>
                                    <div className='stepper-label'>
                                      <h3 className='stepper-title'>
                                        {t('Add Insayr as a commission agent')}
                                      </h3>
                                    </div>
                                  </div>
                                  <div className='h-40px'></div>
                                </div>
                                <div
                                  className='stepper-item cursor-pointer'
                                  onClick={() => setTab('4')}
                                >
                                  <div className='stepper-wrapper'>
                                    <div
                                      className={`stepper-icon w-40px h-40px ${
                                        tab == '4' ? ' bg-success' : 'bg-light-success'
                                      }`}
                                    >
                                      <i className='stepper-check fas fa-check'></i>
                                      <span
                                        className={`stepper-number text-white ${
                                          tab == '4' ? ' text-white' : 'text-success'
                                        }`}
                                      >
                                        4
                                      </span>
                                    </div>
                                    <div className='stepper-label'>
                                      <h3 className='stepper-title'>{t('Contact Us')}</h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='bg-body rounded'>
                            <div className='d-flex flex-row-fluid align-items-end'>
                              {tab == '1' && (
                                <div className='pt-10 w-100 w-xl-700px px-9'>
                                  <div className='current'>
                                    <div className='w-100'>
                                      <div className='pb-10 pb-lg-15'>
                                        <h1 className='fw-bolder d-flex align-items-center text-gray-900'>
                                          {t('Conclusion of the Contract')}
                                        </h1>
                                        <div className='text-gray-800 fw-bold fs-6'>
                                          {t('Review the contract details, terms and policy. If everything is correct and you agree, click the «I AGREE» button below.')}
                                        </div>
                                        <div
                                          className='h-300px p-5 mt-5'
                                          style={{
                                            boxShadow:
                                              'inset 0 5px 10px -5px rgba(0, 0, 0, 0.1),inset 0 -5px 10px -5px rgba(0, 0, 0, 0.1)',
                                          }}
                                        >
                                          {contractPdfUrl && (
                                            <iframe
                                              src={`${contractPdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                                              width='100%'
                                              height='100%'
                                              title={t('PDF Viewer')}
                                              style={{border: 'none', minHeight: '100%'}}
                                            />
                                          )}
                                          {!contractPdfUrl && contractPdfError && (
                                            <div className='d-flex flex-column justify-content-center align-items-center h-100 fw-bold fs-6 text-gray-700'>
                                              <div className='mb-3'>
                                                {t('Unable to load the contract document.')}
                                              </div>
                                              <button
                                                type='button'
                                                className='btn btn-sm btn-light-primary'
                                                onClick={() => loadContractPdf(hotelDetails[0]?.contractPdf)}
                                              >
                                                {t('Retry')}
                                              </button>
                                            </div>
                                          )}
                                          {!contractPdfUrl &&
                                            !contractPdfError &&
                                            hotelDetails[0]?.contractPdf && (
                                              <div className='d-flex justify-content-center align-items-center h-100'>
                                                <span
                                                  className='spinner-border text-primary'
                                                  role='status'
                                                  aria-hidden='true'
                                                ></span>
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {tab == '2' && (
                                <div className='pt-10 w-100 w-xl-700px px-9'>
                                  <div className='current'>
                                    <div className='w-100'>
                                      <div className='pb-10 pb-lg-15'>
                                        <h1 className='fw-bolder d-flex align-items-center text-gray-900'>
                                          {t('Signing via didox.uz')}
                                        </h1>
                                        <div
                                          className='h-300px overflow-y-auto p-5'
                                          style={{
                                            boxShadow:
                                              'inset 0 5px 10px -5px rgba(0, 0, 0, 0.1),inset 0 -5px 10px -5px rgba(0, 0, 0, 0.1)',
                                          }}
                                        >
                                          <div className='fw-bold fs-6 mb-4'>
                                            {t('We will review your listing, and once all the details are correct, we will accept it and send a confirmation to your email.')}
                                          </div>
                                          <div className='fw-bold fs-6 mb-4'>
                                            {tLinks(
                                              'We will also send you the contract below via {didox}, so that you can officially sign it via {didox}.',
                                              {
                                                didox: (
                                                  <a href='https://didox.uz/' target='_blank'>
                                                    didox.uz
                                                  </a>
                                                ),
                                              }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {tab == '3' && (
                                <div className='pt-10 w-100 w-xl-700px px-9'>
                                  <div className='current'>
                                    <div className='w-100'>
                                      <div className='pb-10 pb-lg-15'>
                                        <h1 className='fw-bolder d-flex align-items-center text-gray-900'>
                                          {t('Add Insayr as a commission agent')}
                                        </h1>
                                        <div
                                          className='h-300px overflow-y-auto p-5'
                                          style={{
                                            boxShadow:
                                              'inset 0 5px 10px -5px rgba(0, 0, 0, 0.1),inset 0 -5px 10px -5px rgba(0, 0, 0, 0.1)',
                                          }}
                                        >
                                          <div className='fw-bold fs-6 mb-4'>
                                            {tLinks(
                                              'Dear entrepreneurs! To comply with tax legislation and to be able to adjust receipts, you need to add INSAYR (INSAYR LLC) as a commission agent in your personal account on the {soliq} website. You can find the instructions for adding it at the link: {ikpu}',
                                              {
                                                soliq: (
                                                  <a href='http://my.soliq.uz/' target='_blank'>
                                                    {t('Electronic tax services')}
                                                  </a>
                                                ),
                                                ikpu: (
                                                  <a href='https://insayr.uz/ikpu/' target='_blank'>
                                                    {t('IKPU | INSAYR')}
                                                  </a>
                                                ),
                                              }
                                            )}
                                          </div>
                                          <div className='fw-bold fs-6 mb-10'>
                                            {tLinks(
                                              'After the contract between Insayr and your company is concluded, enter the Insayr company details on {soliq} as a commission agent.',
                                              {
                                                soliq: (
                                                  <a href='http://soliq.uz/' target='_blank'>
                                                    soliq.uz
                                                  </a>
                                                ),
                                              }
                                            )}
                                          </div>
                                          <div className='fw-bold fs-6 mb-6'>
                                            {t('All the required details are listed below:')}
                                          </div>
                                          <div className='fw-bold fs-6'>
                                            {t('CONTRACT NUMBER')}: {t('Check your contract details.')}
                                          </div>
                                          <div className='fw-bold fs-6'>
                                            {t('CONTRACT DATE')}: {t('Check your contract details.')}
                                          </div>
                                          <div className='fw-bold fs-6'>
                                            {t('CONTRACT START')}: {t('Check your contract details.')}
                                          </div>
                                          <div className='fw-bold fs-6 mb-4'>
                                            {t('CONTRACT END')}: {t('31-12-2029 (or 2030)')}
                                          </div>
                                          <div className='fw-bold fs-6'>INSAYR {t('TIN')} 311 312 737</div>
                                          <div className='fw-bold fs-6'>{t('MFO')} 00401</div>
                                          <div className='fw-bold fs-6'>
                                            {t('Settlement account')} 20208000507065045001
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {tab == '4' && (
                                <div className='pt-10 w-100 w-xl-700px px-9'>
                                  <div className='current'>
                                    <div className='w-100'>
                                      <div className='pb-10 pb-lg-15'>
                                        <h1 className='fw-bolder d-flex align-items-center text-gray-900 rounded'>
                                          {t('Contact Us')}
                                        </h1>
                                        <div
                                          className='h-300px overflow-y-auto p-5'
                                          style={{
                                            boxShadow:
                                              'inset 0 5px 10px -5px rgba(0, 0, 0, 0.1),inset 0 -5px 10px -5px rgba(0, 0, 0, 0.1)',
                                          }}
                                        >
                                          <div className='fw-bold fs-6 mb-4'>
                                            {t('For any questions, please contact the 24/7 Insayr support center:')}
                                          </div>
                                          <div className='fw-bold fs-6 mb-4'>
                                            📞 {t('Phone')}: +998 (95) 338 42 02
                                          </div>
                                          <div className='fw-bold fs-6 mb-4'>
                                            <KTIcon
                                              iconName='message-text-2'
                                              className='fs-5 me-2'
                                            ></KTIcon>
                                            {t('Telegram chat')}:{' '}
                                            <a
                                              className='text-success'
                                              href='https://t.me/insayrsupport'
                                              target='_blank'
                                            >
                                              https://t.me/insayrsupport
                                            </a>
                                          </div>
                                          <div className='fw-bold fs-6 mb-4'>
                                            <KTIcon iconName='sms' className='fs-5 me-2'></KTIcon>
                                            {t('Email')}: support@insayr.uz
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className='row'>
                              <div className='col-lg-12'>
                                <div className='d-flex justify-content-between align-items-center'>
                                  {/* <!--end::Button--> */}
                                  <button
                                    type='button'
                                    disabled={disable}
                                    className='btn btn-sm btn-light-warning'
                                    onClick={generateContractPdf}
                                  >
                                    <span className='indicator-label'>
                                      <i className='fa-solid fa-download'></i> {t('Download PDF')}
                                    </span>
                                    {loading && (
                                      <span
                                        className='spinner-border spinner-border-sm mx-2'
                                        role='status'
                                        aria-hidden='true'
                                      ></span>
                                    )}
                                  </button>
                                  <button
                                    type='button'
                                    disabled={isAgreeContract}
                                    className='btn btn-primary'
                                    onClick={contractAgree}
                                  >
                                    <span className='indicator-label'>{t('I AGREE')}</span>
                                    {loading && (
                                      <span
                                        className='spinner-border spinner-border-sm mx-2'
                                        role='status'
                                        aria-hidden='true'
                                      ></span>
                                    )}
                                  </button>
                                  {/* <!--end::Button--> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!--begin::Card body--> */}
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export {ViewHotelContract}
